import { render, staticRenderFns } from "./AddCredentialsOnboarding.vue?vue&type=template&id=391184f5&scoped=true&"
import script from "./AddCredentialsOnboarding.vue?vue&type=script&lang=js&"
export * from "./AddCredentialsOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./AddCredentialsOnboarding.vue?vue&type=style&index=0&id=391184f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391184f5",
  null
  
)

export default component.exports